import React from 'react';
import classNames from 'classnames';

const StatusLabel = props => {
  const { success, info, warning, danger, active, children, className, statuses, title } = props;

  const isActive = active || statuses.includes('active');

  const labelClassName = classNames('label', className, {
    'label-success': success || statuses.includes('success'),
    'label-info': info || statuses.includes('info'),
    'label-warning': warning || statuses.includes('warning'),
    'label-danger': danger || statuses.includes('danger'),
  });

  if (isActive) {
    return (
      <span title={title}>
        <span className="fa fa-spin fa-spinner" /> {children}
      </span>
    );
  }

  return (
    <span className={labelClassName} title={title}>
      {children}
    </span>
  );
};

export default StatusLabel;
